import React, { useEffect } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Skeleton,
    Typography,
} from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import LinkSummaryProgress from "../linksummary/LinkSummaryProgress";


export default function LinkSummaryDialog(props) {
    const { getLinkSummary, linkSummary, open, setOpen, transferDate, getTransferDates } = props

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <Dialog
            fullWidth // Ensure the dialog takes up the full width up to the max width
            maxWidth="sm" // Set the maximum width
            PaperProps={{
                sx: {
                    backgroundColor: 'rgb(34, 34, 34)', // Dark grey background
                    color: 'rgb(255, 255, 255)', // White text color
                },
            }}
            onClose={handleClose}
            open={open}
        >
            <DialogTitle>
                <Box
                    display='flex'
                    justifyContent='space-between'
                    alignItems='center'
                >
                    <Typography>{transferDate} Link Summary</Typography>
                    <IconButton
                        onClick={() => {
                            getLinkSummary(transferDate);
                            getTransferDates();
                        }}
                    >
                        <RefreshIcon sx={{ fontSize: '20px', fill: 'rgb(255, 255, 255)' }} />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent>
                {linkSummary
                ?
                    <Box>
                    {Object.entries(linkSummary?.sources ?? {}).map(([source, summary], index) => (
                        <LinkSummaryProgress
                            key={index}
                            source={source}
                            summary={summary}
                        />
                    ))}
                    </Box>
                :
                    <Box>
                        <Skeleton />
                        <Skeleton />
                        <Skeleton />
                    </Box>
                }
            </DialogContent>
            <DialogActions>
                <Button
                    sx={{ color: 'rgb(255, 255, 255)' }}
                    onClick={handleClose}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}